<div>
  <div class="intro-section" id="intro">
    <p>
      This END USER LICENSE AGREEMENT (<b>"Agreement"</b>) is a binding
      agreement between you (<b>"End User" or "you"</b>) and Appalachian
      Community Capital Corporation (<b>"Company"</b>). This Agreement governs
      your use of the ACC Data Hub (the <b>"Data Hub"</b>). The Data Hub is
      licensed, not sold, to you.
    </p>
    <div class="important-notice">
      <p>
        <strong>IMPORTANT:</strong> BY CLICKING THE "AGREE" BUTTON, YOU (A)
        ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTAND THIS AGREEMENT; (B)
        REPRESENT THAT YOU ARE 18 YEARS OF AGE OR OLDER; AND (C) ACCEPT THIS
        AGREEMENT AND AGREE THAT YOU ARE LEGALLY BOUND BY ITS TERMS. IF YOU DO
        NOT AGREE TO THESE TERMS, DO NOT USE THE DATA HUB.
      </p>
    </div>
  </div>
  <h3 id="license-grant">1. License Grant</h3>
  <p>
    Subject to the terms of this Agreement, Company grants you a limited,
    non-exclusive, and nontransferable license to access and use the Data Hub
    for your business use on a single owned or otherwise controlled by you
    device strictly in accordance with this Agreement.
  </p>
  <h3 id="license-restrictions">2. License Restrictions</h3>
  <div class="restrictions-list">
    <p>You shall not:</p>
    <ul>
      <li>
        <strong>(a)</strong> copy the Data Hub, except as expressly permitted by
        this license, or if exporting in the Data Hub in an authorized manner
        via integration or written access;
      </li>
      <li>
        <strong>(b)</strong> modify, translate, adapt, or otherwise create
        derivative works or improvements, whether or not patentable, of the Data
        Hub;
      </li>
      <li>
        <strong>(c)</strong> reverse engineer, disassemble, decompile, decode,
        or otherwise attempt to derive or gain access to the source code of the
        Data Hub or any part thereof;
      </li>
      <li>
        <strong>(d)</strong> remove, delete, alter, or obscure any trademarks or
        any copyright, trademark, patent, or other intellectual property or
        proprietary rights notices from the Data Hub, including any copy
        thereof; or
      </li>
      <li>
        <strong>(e)</strong> rent, lease, lend, sell, sublicense, assign,
        distribute, publish, transfer, or otherwise make available the Data Hub,
        or any features or functionality of the Data Hub, to any third party for
        any reason, including by making the Data Hub available on a network
        where it is capable of being accessed by more than one device at any
        time.
      </li>
    </ul>
  </div>
  <h3 id="reservation">3. Reservation of Rights</h3>
  <p>
    You acknowledge and agree that the Data Hub is provided under license, and
    not sold, to you. You do not acquire any ownership interest in the Data Hub,
    or the information provided therein, under this Agreement, or any other
    rights thereto other than to use the Data Hub in accordance with the license
    granted, and subject to all terms, conditions, and restrictions, under this
    Agreement. Company and its licensors and service providers reserve and shall
    retain their entire right, title, and interest in and to the Data Hub,
    including all copyrights, trademarks, and other intellectual property rights
    therein or relating thereto, except as expressly granted to you in this
    Agreement.
  </p>
  <h3 id="information">4. Collection and Use of Your Information.</h3>
  <p>
    You acknowledge that when you access and use the Data Hub, Company may use
    automatic means (including, for example, cookies and web beacons) to collect
    information about you and about your use of the Data Hub. All information we
    collect through or in connection with this Data Hub is subject to our
    Privacy Policy. By using, and providing information to or through this Data
    Hub, you consent to all actions taken by us with respect to your information
    in compliance with the Privacy Policy.
  </p>
  <h3 id="user-data">5. End User Data</h3>
  <p>
    You represent and warrant to Company that you have all necessary permissions
    and consents to provide the data you upload to the Data Hub, and any and all
    data you provide to Company will not:
  </p>
  <ul>
    <li>
      <strong>(i)</strong> violate any foreign, federal, state, local or
      provincial law or regulation;
    </li>
    <li>
      <strong>(ii)</strong> infringe any copyright, trademark, patent or other
      proprietary right of any third party;
    </li>
    <li>
      <strong>(iii)</strong> in any way violate or infringe upon any party’s
      privacy right, right of publicity or any other right of any person or
      entity;
    </li>
    <li>
      <strong>(iv)</strong> contain any viruses, worms, trap doors, timers,
      clocks, counters or other limiting routines, instructions or designs; or
    </li>
    <li>
      <strong>(v)</strong> contain any material which is unlawful, hateful,
      obscene, libelous, threatening or defamatory.
    </li>
  </ul>
  <p>
    By uploading the data to the Data Hub or otherwise providing the data to
    Company, you hereby grant Company a limited, non-exclusive license to
    display the data for access by Company and other Data Hub end users. You
    acknowledge that Company has no obligation to monitor any data you upload to
    the Data Hub; however, if Company becomes aware that any item you upload
    does or may violate any warranty or representation made hereunder, you agree
    that Company has the right to remove such item pending resolution, and the
    parties agree to work together promptly and in good faith to remedy any such
    issue. You also authorize Company to share your data on the Data Hub with
    other uses and analyze anonymized versions of the data you upload.
  </p>
  <h3 id="updates">6. Updates</h3>
  <p>
    Company may from time to time in its sole discretion develop and provide
    Data Hub updates, which may include upgrades, bug fixes, patches, other
    error corrections, and/or new features (collectively, including related
    documentation, <b>"Updates"</b>). Updates may also modify or delete in their
    entirety certain features and functionality. You agree that Company has no
    obligation to provide any Updates or to continue to provide or enable any
    particular features or functionality. You further agree that all Updates
    will be deemed part of the Data Hub and be subject to all terms and
    conditions of this Agreement.
  </p>
  <h3 id="third-party">7. Third-Party Materials</h3>
  <p>
    The Data Hub may display, include, or make available third-party content
    (including data, information, Data Hubs, and other products, services,
    and/or materials) or provide links to third-party websites or services (<b
      >"Third-Party Materials"</b
    >). You acknowledge and agree that Company is not responsible for
    Third-Party Materials, including their accuracy, completeness, timeliness,
    validity, copyright compliance, legality, decency, quality, or any other
    aspect thereof. Company does not assume and will not have any liability or
    responsibility to you or any other person or entity for any Third-Party
    Materials. Third-Party Materials and links thereto are provided solely as a
    convenience to you, and you access and use them entirely at your own risk
    and subject to such third parties' terms and conditions.
  </p>
  <h3 id="termination">8. Term and Termination.</h3>
  <ul>
    <li>
      <strong>(a)</strong> The term of Agreement commences when you access the
      Data Hub and will continue in effect until terminated by you or Company as
      set forth in this Section 8.
    </li>
    <li>
      <strong>(b)</strong> You may terminate this Agreement by ceasing to access
      the Data Hub.
    </li>
    <li>
      <strong>(c)</strong> Company may terminate this Agreement at any time
      without notice if it ceases to support the Data Hub, which Company may do
      in its sole discretion. In addition, this Agreement will terminate
      immediately and automatically without any notice if you violate any of the
      terms and conditions of this Agreement.
    </li>
    <li>
      <strong>(d)</strong> Company may terminate your access to the Data Hub at
      any time should you fail to make any subscription payment due to Company,
      if any, in respect of the Data Hub.
    </li>
    <li>
      <strong>(e)</strong> Upon termination:
      <ul>
        <li>
          (i) all rights granted to you under this Agreement will also
          terminate; and
        </li>
        <li>(ii) you must cease all use of the Data Hub.</li>
      </ul>
    </li>

    <li>
      <strong> (f)</strong> Termination will not limit any of Company's rights
      or remedies at law or in equity.
    </li>
  </ul>
  <h3 id="warranties">9. Disclaimer of Warranties.</h3>
  <p>
    THE DATA HUB IS PROVIDED TO END USER "AS IS" AND WITH ALL FAULTS AND DEFECTS
    WITHOUT WARRANTY OF ANY KIND. TO THE MAXIMUM EXTENT PERMITTED UNDER
    APPLICABLE LAW, COMPANY, ON ITS OWN BEHALF AND ON BEHALF OF ITS AFFILIATES
    AND ITS AND THEIR RESPECTIVE LICENSORS AND SERVICE PROVIDERS, EXPRESSLY
    DISCLAIMS ALL WARRANTIES, WHETHER EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE,
    WITH RESPECT TO THE DATA HUB, INCLUDING ALL IMPLIED WARRANTIES OF
    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND
    NON-INFRINGEMENT, AND WARRANTIES THAT MAY ARISE OUT OF COURSE OF DEALING,
    COURSE OF PERFORMANCE, USAGE, OR TRADE PRACTICE. WITHOUT LIMITATION TO THE
    FOREGOING, COMPANY PROVIDES NO WARRANTY OR UNDERTAKING, AND MAKES NO
    REPRESENTATION OF ANY KIND THAT THE DATA HUB WILL MEET YOUR REQUIREMENTS,
    ACHIEVE ANY INTENDED RESULTS, OPERATE WITHOUT INTERRUPTION, MEET ANY
    PERFORMANCE OR RELIABILITY STANDARDS, OR BE ERROR-FREE, OR THAT ANY ERRORS
    OR DEFECTS CAN OR WILL BE CORRECTED. NOTWITHSTANDING THE FOREGOING, AND IN
    NO WAY LIMITING THE FOREGOING DISCLAIMER, COMPANY SPECIFICALLY DISCLAIMS ANY
    SCORES OR RESULTS OBTAINED FROM TOOLS AVAILABLE ON THE DATA HUB, AND IN NO
    WAY SHOULD THE INFORMATION AVAILABLE ON THE DATA HUB BE USED TO ADVISE ON
    THE ELIGIBILITY AND/OR QUALITY OF POTENTIAL BORROWERS OR ENTITIES. END USER
    MUST CONDUCT ITS OWN DUE DILIGENCE AND EXAMINE AND ASSESS THE INFORMATION
    PROVIDED FOR ITSELF. COMPANY ALSO IN NO WAY GUARANTEES THAT USE OF THE DATA
    HUB WILL RESULT IN ANY BUSINESS FOR END USER, OR THE PROVISION OF ELIGIBLE
    BORROWERS THAT END USER MAY DO BUSINESS WITH.
  </p>
  <h3 id="liability">10. Limitation of Liability</h3>
  <p>
    TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL COMPANY
    OR ITS AFFILIATES, OR ANY OF ITS OR THEIR RESPECTIVE LICENSORS OR SERVICE
    PROVIDERS, HAVE ANY LIABILITY ARISING FROM OR RELATED TO YOUR USE OF OR
    INABILITY TO USE THE DATA HUB OR THE CONTENT AND SERVICES FOR:
  </p>
  <ul>
    <li>
      <strong>(a)</strong> PERSONAL INJURY, PROPERTY DAMAGE, LOST PROFITS, COST
      OF SUBSTITUTE GOODS OR SERVICES, LOSS OF DATA, LOSS OF GOODWILL, BUSINESS
      INTERRUPTION, COMPUTER FAILURE OR MALFUNCTION, OR ANY OTHER CONSEQUENTIAL,
      INCIDENTAL, INDIRECT, EXEMPLARY, SPECIAL, OR PUNITIVE DAMAGES.
    </li>
    <li>
      <strong>(b)</strong> DIRECT DAMAGES IN AMOUNTS THAT IN THE AGGREGATE
      EXCEED THE AMOUNT ACTUALLY PAID BY YOU FOR THE DATA HUB.
    </li>
  </ul>
  <p>
    THE FOREGOING LIMITATIONS WILL APPLY WHETHER SUCH DAMAGES ARISE OUT OF
    BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE), OR OTHERWISE AND REGARDLESS
    OF WHETHER SUCH DAMAGES WERE FORESEEABLE OR COMPANY WAS ADVISED OF THE
    POSSIBILITY OF SUCH DAMAGES. SOME JURISDICTIONS DO NOT ALLOW CERTAIN
    LIMITATIONS OF LIABILITY SO SOME OR ALL OF THE ABOVE LIMITATIONS OF
    LIABILITY MAY NOT APPLY TO YOU.
  </p>
  <h3 id="indemnification">11. Indemnification</h3>
  <p>
    You agree to indemnify, defend, and hold harmless Company and its officers,
    directors, employees, agents, affiliates, successors, and assigns from and
    against any and all losses, damages, liabilities, deficiencies, claims,
    actions, judgments, settlements, interest, awards, penalties, fines, costs,
    or expenses of whatever kind, including attorneys' fees, arising from or
    relating to your use or misuse of the Data Hub or your breach of this
    Agreement.
  </p>
  <h3 id="severability">12. Severability</h3>
  <p>
    If any provision of this Agreement is illegal or unenforceable under
    applicable law, the remainder of the provision will be amended to achieve as
    closely as possible the effect of the original term and all other provisions
    of this Agreement will continue in full force and effect.
  </p>
  <h3 id="governing-law">13. Governing Law</h3>
  <p>
    This Agreement is governed by and construed in accordance with the internal
    laws of the Commonwealth of Virginia without giving effect to any choice or
    conflict of law provision or rule. Any legal suit, action, or proceeding
    arising out of or related to this Agreement or the Data Hub shall be
    instituted exclusively in the federal courts of the United States or the
    courts of the Commonwealth of Virginia in each case located in Montgomery
    County. You waive any and all objections to the exercise of jurisdiction
    over you by such courts and to venue in such courts.
  </p>
  <h3 id="entire-agreement">14. Entire Agreement.</h3>
  <p>
    This Agreement and our Privacy Policy constitute the entire agreement
    between you and Company with respect to the Data Hub and supersede all prior
    or contemporaneous understandings and agreements, whether written or oral,
    with respect to the Data Hub
  </p>
  <h3 id="waiver">15. Waiver</h3>
  <p>
    No failure to exercise, and no delay in exercising, on the part of either
    party, any right or any power hereunder shall operate as a waiver thereof,
    nor shall any single or partial exercise of any right or power hereunder
    preclude further exercise of that or any other right hereunder. In the event
    of a conflict between this Agreement and any applicable other terms, the
    terms of this Agreement shall govern.
  </p>
</div>
